import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5e39b60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "password-reset",
  class: "view"
}
const _hoisted_2 = { class: "container" }

import { computed, toRefs, onBeforeMount } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  import PasswordEmailSent from '@/components/User/PasswordReset/PasswordActionDone.vue'
  import PasswordResetRequest from '@/components/User/PasswordReset/PasswordResetForm.vue'

  interface Props {
    action: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    action: null
  },
  setup(__props: any) {

const props = __props as {
    action: string
  }

  

  const route = useRoute()
  const router = useRouter()

  const { action } = toRefs(props)
  const token = computed(() => route.query.token)

  onBeforeMount(() => {
    if (props.action === 'reset' && !token.value) {
      router.push('/')
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(action).startsWith('reset'))
        ? (_openBlock(), _createBlock(PasswordResetRequest, {
            key: 0,
            action: _unref(action),
            token: _unref(token)
          }, null, 8, ["action", "token"]))
        : (_openBlock(), _createBlock(PasswordEmailSent, {
            key: 1,
            action: _unref(action)
          }, null, 8, ["action"]))
    ])
  ]))
}
}

})